module.exports = require('./lib/simple');


// WEBPACK FOOTER //
// ./~/bpmn-moddle/index.js